import Units from "../../../utils/Units";

let gridColor = "rgba(0, 0, 0, 0.1)";
let tickFontSize = 10;
let Time = {
    id: "x-axis-0",
    type: 'time',
    distribution:'series',
    spanGaps: false,
    mode: "x",

    gridLines: {
        color: gridColor,
        zeroLineColor: "rgba(0, 0, 0, 0)"
    },
    time: {
        displayFormats: {
            day:"D.M.",
            hour: "HH:mm"
        },
        unit: 'hour',
        stepSize: 1
    },
    ticks: {
        major: {
            enabled: true,
            fontStyle: 'bold',
            callback: function(value, index, values) {
                return value;
                //return moment(value, "YYYY-MM-DD HH:mm:ss").format("M.D.");
            }
        },
        autoSkip: true,
        autoSkipPadding: 20,
        maxRotation: 0,
        sampleSize: 100,
    }
};

export default Time;



// WEBPACK FOOTER //
// ./src/components/chart/axes/Time.js